import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions/index'
import AssetUpload from '../../content/asset/AssetUpload';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Icon,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton
} from '@material-ui/core';

const styles = theme => ({

});

class UserNoteAssetDialog extends Component {

    render() {
        const { activeNote } = this.props;

        if (!activeNote) {
            return (
                <Dialog
                    open={this.props.is_dialog_open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'sm'}
                    fullWidth
                >
                    <DialogTitle id="alert-dialog-title">{'Loading'}</DialogTitle>
                    <DialogContent>


                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.props.handleClose} color="primary">
                            Cancel
                    </Button>
                    </DialogActions>
                </Dialog>
            )
        }

        const assetList = activeNote ?
            activeNote.AssetList.map(asset => {
                return (
                    <ListItem key={asset.header.asset_id}>
                        <ListItemIcon><a href={asset.header.URL} target="_blank"><Icon>cloud_download</Icon></a></ListItemIcon>
                        <ListItemText><a href={asset.header.URL} target="_blank">{asset.header.AssetName}</a></ListItemText>
                        <ListItemIcon>
                            <IconButton
                                onClick={() => this.props.deleteAsset(asset.header.asset_id, 'user_note_detail', activeNote.user_note_detail_id, this.props.pullAssets)}
                            >
                                <Icon>delete</Icon>
                            </IconButton>
                        </ListItemIcon>
                    </ListItem>
                )
            })
            :
            null

        return (
            <Dialog
                disableRestoreFocus={true}
                open={this.props.is_dialog_open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'md'}
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">{activeNote.ChapterName + ' Assets'}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={6}>
                            <AssetUpload
                                file_type={"User Note"}
                                auth_id={this.props.auth_id}
                                modelType={"user_note_detail"}
                                model_id={this.props.user_note_detail_id}
                                requires_relation={true}
                                getAssetList={() => this.props.pullAssets(this.props.user_note_detail_id)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <List>
                                {assetList}
                            </List>
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUserNoteList: Actions.getUserNoteList,
        editTabName: Actions.editTabName,
    }, dispatch);
}

function mapStateToProps({ note, auth }) {
    return {
        current_user_note_detail_id: note.user_note.current_user_note_detail_id,
        userNoteList: note.user_note.userNoteList,
        current_note_text: note.user_note.current_note_text,
        edit_tab_name: note.user_note.edit_tab_name,
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(UserNoteAssetDialog));



// WEBPACK FOOTER //
// src/main/components/note/UserNoteAssetDialog.js